'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_Key() {
}
export { $c_Lcom_raquo_laminar_keys_Key as $c_Lcom_raquo_laminar_keys_Key };
$p = $c_Lcom_raquo_laminar_keys_Key.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_Key;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_Key() {
}
export { $h_Lcom_raquo_laminar_keys_Key as $h_Lcom_raquo_laminar_keys_Key };
$h_Lcom_raquo_laminar_keys_Key.prototype = $p;
